(() => {
  'use strict';
  const form = document.getElementById('fr-quote');
  if (!form) return;
  const territory = document.getElementById('fr-territory');
  document.querySelectorAll('[data-territory]').forEach(link => link.addEventListener('click', () => {
    territory.value = link.dataset.territory;
  }));
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const selected = territory.options[territory.selectedIndex];
    const variant = document.getElementById('fr-variant');
    const configuration = variant ? variant.options[variant.selectedIndex].text : '';
    const isFitout = form.dataset.service === 'fitout';
    const subject = `[FR-${territory.value}] ${isFitout ? 'Projet d’aménagement VERVE' : 'Demande de devis VERVE'} — ${selected.text}`;
    const body = [
      'Bonjour,', '', 'Je souhaite un devis pour mon projet.',
      `Territoire : ${selected.text}`,
      `Commune / île / code postal : ${form.elements.place.value.trim()}`,
      `Nom / établissement : ${form.elements.name.value.trim()}`, '',
      form.elements.project.value.trim(),
      configuration ? `Configuration : ${configuration}` : '',
      form.dataset.productUrl ? `Produit : ${form.dataset.productUrl}` : '',
      '', 'Merci de préciser les équipements, le transport, les taxes et les délais dans votre proposition.',
      isFitout ? 'Plan ou photos : à joindre à cet e-mail avant l’envoi.' : '',
      '', `Source : ${form.dataset.pageUrl || 'https://fr.vervefitness.com'}`
    ].filter(line => line !== undefined).join('\n');
    window.location.href = `mailto:sales@vervefitness.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    document.getElementById('fr-email-status').textContent = 'Votre messagerie s’ouvre avec un brouillon. Vérifiez-le puis envoyez-le. Si elle ne s’ouvre pas, écrivez directement à sales@vervefitness.com.';
    // An intent event, never an assertion that the email was sent. No personal data.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: 'french_quote_email_prepared', territory: territory.value, service: isFitout ? 'fitout' : 'equipment'});
  });
})();
